// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__9wX9K","backButtonArea":"Detail_backButtonArea__-a8um","backButton":"Detail_backButton__wXa6K"};